import type { GameContext } from '../core/context';
import type { System } from '../core/system';
import { STARTER_BAY } from '../../shared/economy';

/**
 * SCAFFOLD sandbox content: a drivable test car next to the player and one parked example of
 * each vehicle class, so driving can be tested before traffic exists. The traffic module takes
 * over parked-car spawning; trim this once it does.
 */
export function createSandboxSystem(): System {
  let ctx: GameContext;
  return {
    id: 'sandbox',
    order: 260,
    init(c) {
      ctx = c;
    },
    start() {
      const vehicles = ctx.services.get('vehicles');
      const layout = ctx.services.get('layout');
      const spawn = layout.playerSpawn;
      // Test car parked at the kerb just south of the player's spawn, facing along the road: in Coalgate's
      // kerbside strip (its centre 5.6 m off the centre line since the 2026-10 widening, docs/WORLD.md).
      const starter = vehicles.spawn('coupe', { x: spawn.pos.x + STARTER_BAY.dx, z: spawn.pos.z + STARTER_BAY.dz }, { heading: STARTER_BAY.h, tags: ['sandbox'] });
      // Online that bay is Halloran's loaner's (server/economy/loaner.ts): a stranger's coupe there, prompting
      // "Steal the Vesper GT", was the first thing a new character saw — and a theft brings the police.
      ctx.events.on('netJoined', () => {
        if (vehicles.get(starter.id) === starter && starter.occupant === null) vehicles.despawn(starter);
      });
      const types = ['compact', 'saloon', 'van', 'police', 'cab', 'saloon', 'lorry', 'compact'];
      layout.parkedSpots.slice(0, 32).forEach((spot, i) => {
        if (i % 4 !== 0) return;
        const type = types[(i / 4) % types.length]!;
        vehicles.spawn(type, spot.pos, { heading: spot.heading, parked: true, locked: i % 8 === 0, tags: ['sandbox'] });
      });
    },
  };
}
